/* istanbul ignore next */
/* esignore */
const mockDataLayer = () => {
  if (process.env.NODE_ENV !== 'production' && !window.dataLayer) {
    window.dataLayer = [];
  }
};

const gtmReady = () => {
  return !!(
    window.gtm?.ready ||
    (() => {
      window.gtm = window.gtm || { ready: false };
      window.gtm.ready =
        window.gtm.ready ||
        !!(
          window.dataLayer &&
          window.dataLayer.find((o) => o.event === 'gtm.load')
        );

      return window.gtm.ready;
    })()
  );
};

const dataLayerPush = (data) => {
  gtmReady()
    ? window.dataLayer.push(data)
    : setTimeout(() => {
        dataLayerPush(data);
      }, 1000);
};

/**
 * Filter out null/undefined values from object
 */
const filterNullValues = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

/**
 * Verify and convert relative URLs to full URLs
 */
const ensureFullUrl = (url) => {
  if (typeof url === 'string' && url.startsWith('/')) {
    return `${window.location.origin}${url}`;
  }
  return url;
};

/**
 * Apply default values to event data fields
 */
const applyEventDefaults = (eventData) => {
  const nullableFields = [
    'event_name',
    'referral',
    'article_name',
    'articleId',
    'cta_name',
    'link_url',
    'module_name',
    'form_name',
    'product_info',
    'step',
    'store_name',
    'click_area',
    'breadcrumb',
    'product_tab',
    'filter_type',
    'filter_value',
    'event_detail',
    'question_title',
    'click_action',
    'eventCategory',
    'eventAction',
    'eventLabel',
    'service_name',
    'service_category',
  ];

  const defaults = {
    event: eventData.event || 'uaevent',
    ecommerce: eventData.ecommerce || 'undefined',
  };

  nullableFields.forEach((field) => {
    defaults[field] = eventData[field] || null;
  });

  return defaults;
};

export const pushEvent = (eventData) => {
  const dataWithDefaults = applyEventDefaults(eventData);
  let dataLayerData = filterNullValues(dataWithDefaults);

  mockDataLayer();

  if (dataLayerData.link_url) {
    dataLayerData.link_url = ensureFullUrl(dataLayerData.link_url);
  }

  dataLayerPush(dataLayerData);
};

export const pushData = (data) => {
  mockDataLayer();

  if (window.dataLayer && typeof data === 'object' && data !== null) {
    if (data.link_url) {
      data.link_url = ensureFullUrl(data.link_url);
    }

    dataLayerPush(data);
  }
};
